module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /Users/jonshilton/Projects/nick-smith-app/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 3